// AppSnackbar.jsx — the ONE bottom-center notification surface + its state hook
// (SB-042). The Snackbar+Alert block was copied five times (DocBrowser, WorkHours,
// AdminAccounts, SubmitTicket, Login) and the notify state helper twice; two of
// the copies had already drifted (error-only severity, different autohide).
// Convention: `const { snack, notify, clearSnack } = useNotify();` then render
// `<AppSnackbar snack={snack} onClose={clearSnack} />` once per page.
import { useCallback, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

export function useNotify() {
  const [snack, setSnack] = useState({ msg: '', severity: 'info' });
  const notify = useCallback((msg, severity = 'info') => setSnack({ msg, severity }), []);
  const clearSnack = useCallback(() => setSnack((s) => ({ ...s, msg: '' })), []);
  return { snack, notify, clearSnack };
}

export default function AppSnackbar({ snack, onClose, autoHideDuration = 4000 }) {
  return (
    <Snackbar
      open={Boolean(snack.msg)}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity={snack.severity} variant="filled" onClose={onClose}>
        {snack.msg}
      </Alert>
    </Snackbar>
  );
}
